import { combineReducers } from 'redux';

import { State, Type } from '../actions/utils';

import initialState from './initial';
import { clearedDefaults, failedDefaults, requestedDefaults, succeededDefaults } from './utils';

const list = (state: any = initialState.positions.list, action: any) => {
  switch (action.type) {
    case State.actionCleared(Type.GET_POSITION_LIST):
      return clearedDefaults(state);
    case State.actionRequested(Type.GET_POSITION_LIST):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.GET_POSITION_LIST):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.GET_POSITION_LIST):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case State.actionSucceeded(Type.CREATE_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.positions.list;
    default:
      return state;
  }
};

export const positionReducers = combineReducers({
  list,
});
